import { ExportOutlined } from '@ant-design/icons';
import { Button, Col, Row, Tabs, Typography } from 'antd';
import { useEffect, useState } from 'react';

// EZ API
import { generateSubscriptionPortalLink } from 'utils/ez_api/paymentAPIs';

// EZ Utils
import { showNotification } from 'utils/notificationUtil';

export const BillingSetting: React.FC<{}> = ({}) => {
    const [isGeneratingPortalLink, setIsGeneratingPortalLink] = useState(false);

    const handleGeneratePortalLink = () => {
        setIsGeneratingPortalLink(true);

        generateSubscriptionPortalLink()
            .then(res => {
                if (res?.data?.link) {
                    window.open(res.data.link, '_blank');
                } else {
                    showNotification(
                        'error',
                        'Customer ID not found. Please contact support.',
                        'Error Found',
                        5
                    );
                }
            })
            .catch(err => {
                console.log('🚀 ~ handleGeneratePortalLink ~ err:', err.status);
                if (err.response?.status === 400) {
                    showNotification(
                        'error',
                        'Customer ID not found. Please contact support.',
                        'Error Found',
                        5
                    );
                }
            })
            .finally(() => {
                setIsGeneratingPortalLink(false);
            });
    };

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Row>
            <Col span={24}>
                <Row>
                    <Col span={24}>
                        <Typography.Text className="mr-2">
                            Click the button below to manage your subscription or change your
                            payment information.
                        </Typography.Text>
                    </Col>
                    <Col span={24} className="mt-3">
                        <Button
                            type="primary"
                            icon={<ExportOutlined />}
                            loading={isGeneratingPortalLink}
                            onClick={handleGeneratePortalLink}
                        >
                            Manage your subscription
                        </Button>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};
